import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';

import { DsDivider } from '@frontend/ui/divider';
import { CurrencyPipe, DslService, toBoolean } from '@frontend/vanilla/core';

import { AccountMenuItemBase } from '../../account-menu-item-base';

@Component({
    standalone: true,
    imports: [CommonModule, CurrencyPipe, DsDivider],
    selector: 'vn-wallet-balance-sub-item',
    templateUrl: './wallet-balance-sub-item.html',
})
export class WalletBalanceSubItemComponent extends AccountMenuItemBase implements OnInit {
    balance: number;
    hideIfZero: boolean;
    dslService = inject(DslService);

    ngOnInit(): void {
        this.dslService.evaluateExpression<number>(this.item.parameters['formula']!).subscribe((x) => (this.balance = x));
        this.hideIfZero = !!toBoolean(this.item.parameters['hide-if-zero']);
    }
}
